import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Loader, Button } from '@getro/rombo';
import { ConnectionPathCard } from './ConnectionPathCard';
import { useConnectionPaths } from './hooks/useConnectionPaths';

export const ConnectionPaths = ({ contact }) => {
  const { data = [], isFetching, showAll, setShowAll, itemsToRender, hasMore } = useConnectionPaths({ contact });

  if (isFetching) {
    return (
      <Flex alignItems="center" justifyContent="center" py="24px">
        <Loader />
      </Flex>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Text fontSize="14px" color="text.main">
        There are no signals that suggest your team can reach{' '}
        {contact.fullName || contact.linkedinHandle || 'this contact'}.
      </Text>
    );
  }

  return (
    <Flex sx={{ flexDirection: 'column', gap: '12px' }}>
      <Box>
        <Flex sx={{ flexDirection: 'column', gap: '12px' }}>
          {itemsToRender.map((item) => (
            <ConnectionPathCard key={item.id} item={item} />
          ))}
        </Flex>
      </Box>

      {hasMore && (
        <Box textAlign="center" pt="16px">
          {!showAll && (
            <Button variant="secondary" onClick={() => setShowAll(true)}>
              View more
            </Button>
          )}
        </Box>
      )}
    </Flex>
  );
};

ConnectionPaths.propTypes = {
  contact: PropTypes.object.isRequired,
};
